<form class="site-info-panel" name="siteForm">
    <div class="card panel-flat-color primary-panel">
        <div class="panel-flat-header">
            <h3>Site Info</h3>
            <div class="float-end header-button-container">
                @if (showSpinner) {
                    <span> <ws-ace-loader [inline]="true"></ws-ace-loader> Processing... </span>
                }
                @if (!showSpinner && hasInstancePrivatePermission) {
                    <button
                        type="button"
                        helpTooltip
                        helpContentId="site-info-panel.change-history"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="launchChangeHistoryModal()"
                    >
                        <i class="fa fa-history"></i>
                    </button>
                }
                @if (!showSpinner && allowUserToEditEntity && !editMode) {
                    <button
                        type="button"
                        helpTooltip
                        helpContentId="app.edit"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="startEditMode()"
                    >
                        <i class="fa fa-pencil"></i>
                    </button>
                }
                @if (editMode) {
                    <span>
                        <button
                            type="submit"
                            class="ace-btn btn-text has-icon btn-primary btn-success"
                            (click)="saveSite()"
                        >
                            <i class="fa fa-save"></i>
                        </button>
                        <button
                            type="button"
                            class="ace-btn btn-text has-icon btn-primary btn-danger"
                            (click)="cancelEditMode()"
                        >
                            <i class="fa fa-close"></i>
                        </button>
                    </span>
                }
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="panel-flat-body" style="height: 305px">
            <ws-ace-loader [show]="!site" [hasOverlay]="true"></ws-ace-loader>
            @if (site && siteForm) {
                <div>
                    <div class="float-start d-inline-block form-inline" [formGroup]="siteForm">
                        <ws-stamp
                            [dataValue]="site"
                            [visible]="editMode"
                            [activityStatusId]="site.activityStatusID"
                            [transaction]="site.transaction"
                        >
                        </ws-stamp>
                        <div>
                            @if (!editMode) {
                                <h3 style="margin: 0; max-width: initial">{{ site.name }}</h3>
                            }
                            @if (editMode) {
                                <div>
                                    <span class="title">Site Name: </span>
                                    <input
                                        formControlName="name"
                                        class="form-control"
                                        type="text"
                                        name="name"
                                        maxlength="100"
                                        style="width: 288px"
                                        required
                                    />
                                </div>
                            }
                        </div>
                        <div formGroupName="address">
                            <div>
                                @if (!editMode) {
                                    <span>{{ site.address.address1 }}</span>
                                }
                                @if (editMode) {
                                    <div>
                                        <span class="title">Address:</span>
                                        <input
                                            formControlName="address1"
                                            class="form-control"
                                            type="text"
                                            name="address1"
                                            maxlength="50"
                                            style="width: 288px"
                                            required
                                        />
                                    </div>
                                }
                            </div>
                            <div>
                                @if (!editMode && site.address.address2) {
                                    <span style="padding-top: 0; display: inherit">{{ site.address.address2 }}</span>
                                }
                                @if (editMode) {
                                    <div>
                                        <span class="title"></span>
                                        <input
                                            formControlName="address2"
                                            class="form-control"
                                            type="text"
                                            name="address2"
                                            maxlength="50"
                                            style="width: 288px"
                                        />
                                    </div>
                                }
                            </div>
                            <div>
                                @if (!editMode) {
                                    <span
                                        >{{ site.address.city }} , {{ getState(site.address.stateID) }}
                                        {{ site.address.zip }}</span
                                    >
                                }
                                @if (editMode) {
                                    <div style="display: flex; align-items: center">
                                        <span class="title"></span>
                                        <input
                                            formControlName="city"
                                            class="form-control"
                                            style="width: 145px; vertical-align: top"
                                            type="text"
                                            name="city"
                                            maxlength="50"
                                            required
                                        />
                                        @if (hasParcels()) {
                                            <span style="margin: 0 5px">{{ getState(site.address.stateID) }}</span>
                                        }
                                        @if (!hasParcels()) {
                                            <ws-select
                                                formControlName="stateID"
                                                [options]="states"
                                                labelProperty="abbr"
                                                valueProperty="stateID"
                                                style="vertical-align: top"
                                            ></ws-select>
                                        }
                                        <input
                                            formControlName="zip"
                                            class="form-control"
                                            style="width: 58px; vertical-align: top"
                                            type="text"
                                            name="zip"
                                            maxlength="10"
                                            required
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <div>
                            @if (site.property || editMode) {
                                <span class="title">Site Number: </span>
                            }
                            <span class="editable">
                                @if (site.property && !editMode) {
                                    <span>{{ site.property }}</span>
                                }
                                @if (editMode) {
                                    <input
                                        formControlName="property"
                                        class="form-control"
                                        type="text"
                                        name="property"
                                        maxlength="100"
                                        style="width: 288px"
                                        required
                                    />
                                }
                            </span>
                        </div>
                        @if (!editMode) {
                            <div>
                                <span class="title"
                                    >Assessor
                                    @if (site.assessors && site.assessors.length > 1) {
                                        <span>s</span>
                                    }
                                    :</span
                                >
                                <span class="editable">
                                    @for (assessor of site.assessors; track assessor; let last = $last) {
                                        <span>
                                            <a
                                                class="clickable"
                                                helpTooltip
                                                position="right"
                                                [contentComponent]="customRenderer"
                                                [contentComponentValue]="assessor"
                                                (click)="goToAssessor(assessor)"
                                                >{{ assessor.abbr }} {{ assessor.municipalityName }}</a
                                            >
                                            @if (!last) {
                                                <span>,</span>
                                            }
                                        </span>
                                    }
                                </span>
                            </div>
                        }
                        <div>
                            <span class="title">Site Class: </span>
                            <span class="editable">
                                @if (!editMode) {
                                    <span>{{ getSiteClassName(site.siteClassSecondaryID) }}</span>
                                }
                                @if (editMode) {
                                    <ws-select
                                        formControlName="siteClassSecondaryID"
                                        [options]="siteClasses"
                                        labelProperty="name"
                                        valueProperty="siteClassSecondaryID"
                                    ></ws-select>
                                }
                            </span>
                        </div>
                        @if (site.accrualsEnabled) {
                            <div formGroupName="accrualsExclude">
                                @if (site.accrualsExclude.parentExcludedFromAccruals) {
                                    <div>
                                        <span class="title">Parent Excluded From Accruals</span>
                                    </div>
                                }
                                @if (!site.accrualsExclude.parentExcludedFromAccruals) {
                                    <div class="editable">
                                        <label>
                                            <input type="checkbox" formControlName="excludeFromAccruals" />
                                            <span style="margin-left: 2px">Exclude From Accruals</span>
                                        </label>
                                    </div>
                                }
                            </div>
                        }
                        @if (editMode) {
                            <div>
                                <span class="title">Status: </span>
                                <ws-select
                                    formControlName="activityStatusID"
                                    [options]="activityStatuses"
                                    labelProperty="status"
                                    valueProperty="activityStatusId"
                                    [popover]="activatedByPopover"
                                    triggers="mouseenter:mouseleave"
                                    container="body"
                                ></ws-select>
                            </div>
                        }
                        <!-- Sold Date -->
                        @if (editMode) {
                            <div>
                                <span class="title">Sold Date: </span>
                                <weissman-datetime
                                    [dateOnly]="true"
                                    [inputDate]="$any(siteForm).controls.transaction.controls.soldDate.value"
                                    (inputDateChange)="onSoldDateChanged($event)"
                                >
                                </weissman-datetime>
                            </div>
                        }
                        @if (!editMode) {
                            <div>
                                <linked-sites
                                    [site]="site"
                                    [masterSiteId]="site.masterSiteId"
                                    [sites]="site.linkedSites"
                                ></linked-sites>
                            </div>
                        }
                        @if (editMode) {
                            <div style="padding-top: 20px">
                                <button
                                    type="button"
                                    class="ace-btn btn-sm btn-primary btn-danger"
                                    helpTooltip
                                    helpContentId="app.delete"
                                    [disabled]="showSpinner"
                                    (click)="deleteSite()"
                                >
                                    Delete
                                </button>
                                <div
                                    helpTooltip
                                    [tooltipText]="!site.canMove ? site.canMoveMessage : 'Move'"
                                    style="display: inline-block"
                                >
                                    @if (hasMoveCopyPermission) {
                                        <button
                                            [disabled]="showSpinner || !site.canMove"
                                            class="ace-btn btn-sm btn-primary"
                                            (click)="goToMove()"
                                        >
                                            Move
                                        </button>
                                    }
                                </div>
                                @if (hasMoveCopyPermission) {
                                    <button
                                        helpTooltip
                                        helpContentId="site-info-panel.copy"
                                        [disabled]="showSpinner"
                                        class="ace-btn btn-sm btn-primary"
                                        (click)="goToCopy()"
                                    >
                                        Copy
                                    </button>
                                }
                                <linked-sites-edit [site]="site" [isDisabled]="showSpinner"></linked-sites-edit>
                            </div>
                        }
                    </div>
                    @if (!editMode) {
                        <div class="float-end" style="margin-top: 20px">
                            @if (site.hasImages) {
                                <div>
                                    <entity-attachments
                                        buttonClass="has-icon btn-lg"
                                        helpTooltip
                                        helpContentId="site-info-panel.images"
                                        position="left"
                                        [isNestedModal]="false"
                                        [forImages]="true"
                                        (hasImagesChange)="site.hasImages = $event"
                                        [modalData]="attachmentsModel"
                                    >
                                    </entity-attachments>
                                </div>
                            }
                            <div>
                                <entity-attachments
                                    buttonClass="has-icon btn-lg"
                                    helpTooltip
                                    helpContentId="site-info-panel.attachments"
                                    position="left"
                                    [isNestedModal]="false"
                                    [(hasAttachments)]="site.hasAttachments"
                                    [modalData]="attachmentsModel"
                                >
                                </entity-attachments>
                            </div>
                            <div>
                                @if (permissionsLoaded) {
                                    <entity-comments
                                        [hasComments]="site.hasComments"
                                        buttonClass="has-icon btn-lg"
                                        [modalData]="getCommentsModalData()"
                                        helpTooltip
                                        helpContentId="site-info-panel.comments"
                                        position="left"
                                    >
                                    </entity-comments>
                                }
                            </div>
                            @if (site.address.latitude && this.site.address.longitude) {
                                <div>
                                    <button
                                        class="ace-btn has-icon btn-lg btn-primary"
                                        (click)="launchSiteMap()"
                                        helpTooltip
                                        helpContentId="site-info-panel.map"
                                        position="left"
                                    >
                                        <i class="fa fa-map"></i>
                                    </button>
                                </div>
                            }
                            @if (site.canViewValuationTool) {
                                <div>
                                    <a
                                        class="ace-btn has-icon btn-lg btn-primary"
                                        [href]="site.valuationToolUrl"
                                        target="_blank"
                                        helpTooltip
                                        position="left"
                                        helpContentId="site-info-panel.cre"
                                    >
                                        <i class="fa fa-dollar"></i>
                                    </a>
                                </div>
                            }
                        </div>
                    }
                    <div class="clearfix"></div>
                </div>
            }
        </div>
    </div>
</form>

<ng-template #activatedByPopover>
    @if (!site.activatedDateTime && !site.inactivatedDateTime) {
        <div> Activation/Inactivation date information is not available for this site. </div>
    }
    @if (site.activatedDateTime > site.inactivatedDateTime) {
        <div>
            @if (site.activatedBy) {
                <div>
                    Activated by {{ site.activatedBy }} <br />
                    Date:
                    <weissman-datetime
                        [timeZone]="'Central'"
                        [dateOnly]="true"
                        [(inputDate)]="site.activatedDateTime"
                        [readOnly]="true"
                    ></weissman-datetime>
                </div>
            }
            @if (site.inactivatedBy || site.inactivatedDateTime) {
                <div style="margin-top: 10px">
                    Inactivated
                    @if (site.inactivatedBy) {
                        <span>by {{ site.inactivatedBy }}</span>
                    }
                    <br />
                    Date:
                    <weissman-datetime
                        [timeZone]="'Central'"
                        [dateOnly]="true"
                        [(inputDate)]="site.inactivatedDateTime"
                        [readOnly]="true"
                    ></weissman-datetime>
                </div>
            }
        </div>
    }
    @if (site.activatedDateTime <= site.inactivatedDateTime) {
        <div>
            @if (site.inactivatedBy || site.inactivatedDateTime) {
                <div style="margin-top: 10px">
                    Inactivated
                    @if (site.inactivatedBy) {
                        <span>by {{ site.inactivatedBy }}</span>
                    }
                    <br />
                    Date:
                    <weissman-datetime
                        [timeZone]="'Central'"
                        [dateOnly]="true"
                        [(inputDate)]="site.inactivatedDateTime"
                        [readOnly]="true"
                    >
                    </weissman-datetime>
                </div>
            }
            @if (site.activatedBy) {
                <div>
                    Activated by {{ site.activatedBy }} <br />
                    Date:
                    <weissman-datetime
                        [timeZone]="'Central'"
                        [dateOnly]="true"
                        [(inputDate)]="site.activatedDateTime"
                        [readOnly]="true"
                    >
                    </weissman-datetime>
                </div>
            }
        </div>
    }
</ng-template>
